import React from 'react';
import { useSearchParams } from 'react-router-dom';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Container, i18n } from '../../../../symphony';

import { QuestionsPaginationContainer } from '../QuestionsPaginationContainer/QuestionsPaginationContainer';
import { HotToday } from '../HotToday/HotToday';
import { QuestionsSearch } from '../QuestionsSearch/QuestionsSearch';
import { QuestionsFilter } from '../QuestionsFilter/QuestionsFilter';
import { QuestionsList } from '../QuestionsList/QuestionsList';
import { SlDiscussContext } from '../../global-constants';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { useComponentWillMount } from '../../../../shared/public/SlUtils/useComponentWillMount';
import { SlHelmet } from '../../../../shared/public/SlHelmet/SlHelmet';

import s from './QuestionsListPage.scss';

export function QuestionsListPage() {
	useStyles(s);
	const [searchParams] = useSearchParams();
	const { actions$ } = Container.take(SlDiscussContext, SlActions);

	useComponentWillMount(() => {
		actions$.next({
			type: ActionType.OnDiscussQuestionsListPageMount,
			requestType: RequestType.Parallel,
		});
	});

	return (
		<>
			<SlHelmet title={i18n.t('web-discuss.catalog-meta-title')} />
			<div className="discuss-questions-list-page">
				<div className="discuss-questions-list-page__questions-section">
					<h1 className="discuss-questions-list-page__questions-section__title">
						{i18n.t('web-discuss.catalog-title')}
					</h1>
					<QuestionsSearch />
					<QuestionsFilter />
					<QuestionsList
						key={[
							searchParams.get('page'),
							searchParams.get('ordering'),
							searchParams.get('query'),
						].join('-')}
					/>
					<QuestionsPaginationContainer />
				</div>
				<HotToday />
			</div>
		</>
	);
}
